import * as Sentry from "@sentry/nextjs";

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;

/**
 * 
 * @type {Options | clientSdk.BrowserOptions | serverSdk.NodeOptions | edgeSdk.EdgeOptions} 
 */
const init = (options) => {
  Sentry.init({
    dsn: SENTRY_DSN,
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 0,

    release: process.env.NEXT_PUBLIC_COMMIT_VERSION,
    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
    ...options,

    beforeBreadcrumb: (breadcrumb, hint) => {
      if (breadcrumb.message?.includes('chrome')) {
        return null
      }

      if (breadcrumb.message?.includes('padding')) {
        return null
      }

      return breadcrumb
    }
  });
}

export default init